import { Link, classnames as cx, Component } from "@mna/react";
import Form from "@mna/react-ui/Form";
import schema from "@mna/schema";
import { Trans } from "react-i18next";
import { googleMapsApiKey } from "client.config";
import PlacesAutocomplete from "react-places-autocomplete";
import Switch from "react-switch";
import PhoneInput2 from "react-phone-input-2";
import i18next from "i18next";
import Modal from "react-modal";
import LoadingScreen from "features/LoadingScreen";
import i18n from "./../../../i18n";
import {
    checkAndGetLocalStorageValue,
    checkAndGetSessionStorageValue,
    getDate,
    check,
    generateJsonWebToken,
    translateContent,
    getAndSetTranslateVal,
    checkAndChangeContent,
} from "../../../features/utils";
import { commonConstant,telemedicineVendors } from "../../../server/triage/constants";

const formSchema = schema(({ string }) => ({
	phone: string,
	email: string,
	effectTo: string,
	effectFrom: string,
	insurance: string,
	policyNum: string,
	username : string,
	hotelname:string,
	roomnumber:string,
	roomregistered:string
}));

let valuedata;
let lang;
const initialState = {
	shouldUiBeChanged: false,
};
var policyFromMinDate = getDate(new Date(), -1);
var getCurrentDate = getDate(new Date(),0)
var policyToMinDate = getDate(new Date(),0);
var policyToMaxDate = "";

export default class Housevisit extends Component {
	state = initialState;
	constructor(props) {
		super(props);
		this.state = {
			mapLoaded: false,
			geoAddress: "",
			showError: false,
			shouldUiBeChanged: false,
			checked: true,
			phoneError: true,
			value: ''
		};
		this.handleChange = this.handleChange.bind(this);
		this.onChange = this.onChange.bind(this)
	}
	initMap = () => {
		this.setState({
			mapLoaded: true,
		});
	};
	componentDidMount() {
		const { setState } = this.props;
		setState({
			isLoading: false,
		});
		window.initMap = this.initMap;
		const gmapScriptEl = document.createElement(`script`);
		gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places&callback=initMap`;
		document
			.querySelector(`body`)
			.insertAdjacentElement(`beforeend`, gmapScriptEl);
	}
	handleGeoChange = (address) => {
		this.setState({ geoAddress: address });
	};
	handleChange(checked) {
		this.setState({ checked });
	}

	onChange(e){
		const re = /^[0-9\b]+$/;
		if (e.target.value === '' || re.test(e.target.value)) {
		   this.setState({value: e.target.value})
		}
	 } 
	

	render() {
		const {
			state,
			actions,
			history,
			previousStepName,
			nextStepName,
			setState,
		} = this.props;
		const houseVisit = "House Visit"
		return (
			<div className="content-width mt-3">
				<Form
					fields={state.triageRequest.serviceRequest}
					onValidate={(data) => {
						const errors = {};
						const required = "REQUIRED";
						const invalid = "INVALID";

						var s = formSchema(data);
						if (data.locationType === commonConstant.locationTypeEmpty) errors.locationType = invalid;
						if (s.phone === required) errors.phone = required;
						if (s !== null) {
							if (checkAndGetSessionStorageValue("IsValidUser") === "true") {
								if (s.username === required) errors.username = required;
								if (data.locationType === commonConstant.locationTypeHotel ) {
									if (s.hotelname === required) errors.hotelname = required;
									if (s.roomnumber === required) errors.roomnumber = required;
									if (s.roomregistered === required)
										errors.roomregistered = required;
								}
								if(state.triageResponse.vendorsList[0] && state.triageResponse.vendorsList[0].nameLocalization !== undefined){
									if (
										state.triageResponse.vendorsList[0].nameLocalization
										  .localizations[0].value ===
										telemedicineVendors.oneEightHundredMD || state.triageResponse.vendorsList[0].nameLocalization
										.localizations[0].value ===
									  telemedicineVendors.Maple
									  ) {
										if (
										  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(
											data.phone
										  ) === false
										) {
										  this.setState({ phoneError: false });
										  errors.phone = required;
										}
									  } else {
										if ((data.phone).length <= 4) {
										  errors.phone = required;
										}
									  }	
								} else {
									if ((data.phone).length <= 4) {
									  errors.phone = required;
									}
								  }	
								
								if (s.email === required) errors.email = required;
								if (s.effectTo === required) errors.effectTo = required;
								if (s.effectFrom === required) errors.effectFrom = required;
								if (s.insurance === required) errors.insurance = required;

								if (s.policyNum === required) errors.policyNum = required;
							}
						}
						if (checkAndGetLocalStorageValue("careoption") == houseVisit) {
							if(state.triageResponse.vendorsList[0] && state.triageResponse.vendorsList[0].nameLocalization !== undefined){
							if (
							  state.triageResponse.vendorsList[0].nameLocalization
								.localizations[0].value ===
							  telemedicineVendors.oneEightHundredMD || state.triageResponse.vendorsList[0].nameLocalization
							  .localizations[0].value ===
							telemedicineVendors.Maple
							) {
							  if (
								/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(
								  data.phone
								) === false
							  ) {
								this.setState({ phoneError: false });
								errors.phone = required;
							  }
							} else {
							  if ((data.phone).length <= 4) errors.phone = required;
							}
						}
						else {
							if ((data.phone).length <= 4) errors.phone = required;
						  }
						  }
						if (Object.keys(errors).length) return errors;
					}}
					onSubmit={async (data) => {
						setState({
							valuedata: data,
						});
						actions.setTriageServiceRequest(data);
						state.triageRequest.data = data;
						state.triageRequest.insuredInfo =
							data.insuredOn || data.InsuredBirthday || data.sex || data.relation;
						await actions.submitTriageHouseVisit(state, valuedata);
						state.triageRequest.checked =  this.state.checked

						if (checkAndGetSessionStorageValue("IsValidUser") === "false") {
							history.push(`/find-care-options/patientdetails-confo-screen`);
						} else {
							setState({
								isLoading: true,
							});
							let lantest = i18n.language;
							lang = actions.getLanguage(lantest);
							const { triageRequest } = state;
							const {
								sessionId,
								street,
								lat,
								lng,
								city,
								province,
								postalCode,
								country,
							} = triageRequest;
							var localCity = checkAndGetSessionStorageValue("city");
							var localCountry = checkAndGetSessionStorageValue("country");
							var localLocation = checkAndGetSessionStorageValue("currentLocationName");
							var localState = checkAndGetSessionStorageValue("state");

							 var translateArray = [
                                 {
                                     text: country,
                                 },
                                 {
                                     text: data.location,
                                 },
                                 {
                                     text: city,
                                 },
                                 {
                                     text: localCity,
                                 },
                                 {
                                     text: localCountry,
                                 },
                                 {
                                     text: localLocation,
                                 },
                                 {
                                     text: localState,
                                 },
                             ];
                             var translatedContent = await translateContent(
                                 translateArray,
                                 "en"
                             );
                             var listOfTranslatedArr =
                                 translatedContent.response.results;

							var modifiedCountry = await getAndSetTranslateVal( listOfTranslatedArr, 0, country );
							modifiedCountry = checkAndChangeContent(modifiedCountry, commonConstant.USA);
							
							var modifiedLocation = await getAndSetTranslateVal( listOfTranslatedArr, 1, data.location );
							var modifiedCity = await getAndSetTranslateVal( listOfTranslatedArr, 2, city );

							var modifiedLocalCity = await getAndSetTranslateVal( listOfTranslatedArr, 3, localCity );
							var modifiedLocalCountry = await getAndSetTranslateVal( listOfTranslatedArr, 4, localCountry );
							
							modifiedLocalCountry = checkAndChangeContent(modifiedLocalCountry, commonConstant.USA);

							var modifiedLocalLocation = await getAndSetTranslateVal( listOfTranslatedArr, 5, localLocation );
							var modifiedLocalState = await getAndSetTranslateVal( listOfTranslatedArr, 6, localState );

							const encounterToken = checkAndGetLocalStorageValue("token");
							var jwtAccess_Token = generateJsonWebToken();
							var access_Token = checkAndGetSessionStorageValue("accessToken");
							var moment = require("moment-timezone");
							const modifiedData = {
								address: street,
								city: modifiedCity,
								country: modifiedCountry,
								enteredLocationName: modifiedLocation,
								identifier: sessionId,
								isEmergency: false,
								latitude: lat,
								longitude: lng,
								token: encounterToken,
								state: province,
								zip: postalCode,
								jwtAccessToken: jwtAccess_Token,
								accessToken: access_Token,
								coordinationType:1,
							};
							const reqData = {
                                address: "",
                                city: modifiedLocalCity,
                                country: modifiedLocalCountry,
                                enteredLocationName: modifiedLocalLocation,
                                identifier: sessionId,
                                isEmergency: false,
                                latitude: checkAndGetSessionStorageValue("lat"),
                                longitude:
                                    checkAndGetSessionStorageValue("lng"),
                                token: encounterToken,
                                state: modifiedLocalState,
                                zip: "",
                                jwtAccessToken: jwtAccess_Token,
                                accessToken: access_Token,
								coordinationType:1,
                            };

														const locationData = data.location.trim()
								? modifiedData
								: reqData;
							const locationTime = data.location
								? moment()
										.tz(
											state.triageRequest.country +
												"/" +
												state.triageRequest.city
										)
										.format()
								: moment()
										.tz(
											checkAndGetSessionStorageValue("country") +
												"/" +
												checkAndGetSessionStorageValue("city")
										)
										.format();
							var locationResponse = await actions.sendTriageRequest({
								action: "submitLocation",
								data: locationData,
							});

							var houseResponse = await actions.sendTriageRequest({
								action: "getScoreFromAnswers",
								data: {
									identifier: sessionId,
									Token: encounterToken,
									LanguageId: actions.getLanguage(lang),
									Unit: "Km",
									Time: locationTime,
									Radius: 40,
									Translate: false,
									LanguageTo: "de",
									jwtAccessToken: jwtAccess_Token,
									accessToken: access_Token,
								},
							});
							var services = [];
							const houseVisit = "House Visit";

							if (houseResponse.response.services !== null) {
								for (
									let i = 0;
									i < houseResponse.response.services.length;
									i++
								) {
									services.push(houseResponse.response.services[i].service);

									var findService = services.find(
										(value) => value === houseVisit
									);

									if (findService === houseVisit) {
										setState({
											isHcCoverageAvailable: false,
										});

										history.push(`/find-care-options/${nextStepName}`);
									} else {
										setState({
											isHcCoverageAvailable: true,
											isLoading: false,
										});
									}
								}
							} else {
								setState({
									isLoading: false,
									isHcCoverageAvailable: true,
								});
							}
						}
					}}
				>
					{({ fields, invalidFields, isValid, setFields }) => (
						<LoadingScreen isLoading={state.isLoading}>
							<h4 className="text-center">
								<Trans i18nKey="findcareoption.Careoptions.housevisit.HouseVisitHeading">
									Request a House Visit
								</Trans>
							</h4>
							{checkAndGetSessionStorageValue("IsValidUser") === "true" ?
								<>
									<h5>
										<Trans i18nKey="Aboutyou">About you:</Trans>
									</h5>
									<input
										type="text"
										name="username"
										className={cx(invalidFields.username ? "is-error" : "")}
										placeholder={i18next.t("findcareoption.Start.Name")}
										defaultValue={state.triageRequest.data.username}
									/>
									</> : ""
					}
									<div className="pt-1 pb-2">
									<PhoneInput2
									  country={!state.triageResponse.vendorsList[0] || !state.triageResponse.vendorsList[0].nameLocalization
										 ? "us" : state.triageResponse.vendorsList[0].nameLocalization
										.localizations[0].value ===
									telemedicineVendors.oneEightHundredMD? "us" : state.triageResponse.vendorsList[0].nameLocalization
									.localizations[0].value ===
									telemedicineVendors.Maple ? "ca" : "us"  }

									  onlyCountries={!state.triageResponse.vendorsList[0] || !state.triageResponse.vendorsList[0].nameLocalization
										? "" : state.triageResponse.vendorsList[0].nameLocalization
										.localizations[0].value ===
									  telemedicineVendors.oneEightHundredMD? ["us", "ca"] : (state.triageResponse.vendorsList[0].nameLocalization
									  .localizations[0].value ===
									   telemedicineVendors.Maple ? ["ca"] : "")}
									
									   inputProps={{
										name: "phone",
									  }}                      
									  inputClass={cx(invalidFields.phone ? "is-error" : "")}
									  value={
										state.triageRequest.data
												? state.triageRequest.data.phone
												: fields.phone
									  }
									  placeholder={i18next.t(
										"findcareoption.Careoptions.PhoneNumber"
									)}
									  onChange={(phone) =>
										this.setState({ phone, phoneError: true })
									  }
									  isValid={() => {
										if(!state.triageResponse.vendorsList[0] || state.triageResponse.vendorsList[0].nameLocalization === undefined) {
											return true;										
										}
										else {
											if (state.triageResponse.vendorsList[0].nameLocalization
												.localizations[0].value ===
											  telemedicineVendors.oneEightHundredMD || state.triageResponse.vendorsList[0].nameLocalization
											  .localizations[0].value ===
											   telemedicineVendors.Maple) {
												if (this.state.phoneError === false) {                       
													return i18next.t("findcareoption.Careoptions.telemedicine.PhoneValidationmsg")
												}
												else {                     
													return true;
												  }
											 } else {                         
												  return true;
												}
										}
									  }}
									/>																		
								  </div> 

									<input
										type="text"
										name="email"
										className={cx(invalidFields.email ? "is-error" : "")}
										placeholder={i18next.t(
											"findcareoption.Careoptions.EmailAddress"
										)}
										defaultValue={
											checkAndGetLocalStorageValue("userEmail")
												? checkAndGetLocalStorageValue("userEmail")
												: fields.email
										}
									/>

									{checkAndGetSessionStorageValue("IsValidUser") === "true" ? (
										<>
									<div className="w-col pr-3 pl-0 w-col-6 w-col-tiny-tiny-stack">
										<h5>
											<Trans i18nKey="Preferredcontact">
												Preferred contact method
											</Trans>
										</h5>
									</div>
									<div className="w-col pt-2 w-col-3 w-col-tiny-tiny-stack">
										<input
											id="gender-radio"
											type="radio"
											value={i18next.t(
												"findcareoption.Careoptions.Phone"
											  )}
											onChange={(e) => {
												state.triageRequest.userContact = e.currentTarget.value;
											}}
											name="contact"
											pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
											className="w-radio-input"
										/>
										<span className="w-radio w-radio-textsize">
											<Trans i18nKey="findcareoption.Careoptions.Phone">
												Phone
											</Trans>
										</span>
									</div>
									<div classname="w-col pt-2 w-col-3 w-col-tiny-tiny-stack">
										<input
											id="gender-radio-1"
											type="radio"
											value={i18next.t(
												"findcareoption.Careoptions.sendinfo.Email"
											  )}
											onChange={(e) => {
												state.triageRequest.userContact = e.currentTarget.value;
											}}
											name="contact"
											pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
											className="w-radio-input"
										/>
										<span className="w-radio mt-2 w-radio-textsize">
											<Trans i18nKey="findcareoption.Careoptions.sendinfo.Email">
												Email
											</Trans>
										</span>
									</div>
									<h5>
										<Trans i18nKey="LocationInfo">Location Info:</Trans>
									</h5> </> 
									) : 
									"" }
									<select
										name="locationType"
										className={cx(invalidFields.locationType ? "is-error" : "")}
										value={fields.locationType}
										onChange={(e) =>
											setFields({
												locationType: e.target.value,
												hotelname: "",
												roomnumber: "",
												roomregistered: "",
											})
										}
									
									>
										<option value={commonConstant.locationTypeEmpty}>
											{" "}
											{i18next.t(
												"findcareoption.Careoptions.housevisit.HousevisitDrpdnValue1"
											)}
										</option>
										<option value={commonConstant.locationTypeHouse}>
											{i18next.t(
												"findcareoption.Careoptions.housevisit.HousevisitDrpdnValue2"
											)}
										</option>
										<option value={commonConstant.locationTypeHotel}>
											{i18next.t(
												"findcareoption.Careoptions.housevisit.HousevisitDrpdnValue3"
											)}
										</option>
									</select>

									{fields.locationType === commonConstant.locationTypeHotel ? (
										<>
											<input
												type="text"
												name="hotelname"
												placeholder={i18next.t(
													"findcareoption.Careoptions.HotelName"
												)}
												defaultValue={fields.hotelname}
												className={cx(invalidFields.hotelname ? "is-error" : "")}
											/>
											<input
												type="text"
												name="roomnumber"
												placeholder={i18next.t(
													"findcareoption.Careoptions.Room"
												)}
												maxLength="5" 
												//value={this.state.value}
                      							onChange={this.onChange}
												defaultValue={fields.roomnumber}
												className={cx(invalidFields.roomnumber ? "is-error" : "")}
											/>
											<input
												type="text"
												name="roomregistered"
												placeholder={i18next.t(
													"findcareoption.Careoptions.housevisit.Roomregistered"
												)}
												defaultValue={fields.roomregistered}
												className={cx(invalidFields.roomregistered ? "is-error" : "")}
											/>
										</>
									) : (
										<></>
									)}
									{checkAndGetSessionStorageValue("IsValidUser") === "true" ? (
										<>
									<div className=" w-col-tiny-tiny-stack">
										{this.state.mapLoaded && (
											<PlacesAutocomplete
												value={this.state.geoAddress}
												onChange={this.handleGeoChange}
												onSelect={(address, placeId) => {
													var request = {
														placeId: placeId,
													};
													console.log("placeId", placeId, "address", address);
													new Promise((resolve, reject) => {
														new google.maps.places.PlacesService(
															document.createElement("div")
														).getDetails(request, (place, status) => {
															if (
																status ==
																google.maps.places.PlacesServiceStatus.OK
															) {
																let postalCode = "";
																let country = "";
																let province = "";
																let city = "";
																let street = "";
																let street_number = "";
																for (
																	var placesIndex = 0;
																	placesIndex < place.address_components.length;
																	placesIndex++
																) {
																	{
																		console.log(
																			"place.geometry",
																			place.geometry,
																			"place.geometry.langitude",
																			place.geometry.location.lat(),
																			"lng",
																			place.geometry.location.lng()
																		);
																	}
																	for (
																		var streetNumberIndex = 0;
																		streetNumberIndex <
																		place.address_components[placesIndex].types
																			.length;
																		streetNumberIndex++
																	) {
																		if (
																			place.address_components[placesIndex]
																				.types[streetNumberIndex] ===
																			"street_number"
																		) {
																			street_number =
																				place.address_components[placesIndex]
																					.long_name;
																		}
																	}
																	for (
																		var streetIndex = 0;
																		streetIndex <
																		place.address_components[placesIndex].types
																			.length;
																		streetIndex++
																	) {
																		if (
																			place.address_components[placesIndex]
																				.types[streetIndex] === "route" ||
																			place.address_components[placesIndex]
																				.types[streetIndex] === "street"
																		) {
																			street =
																				place.address_components[placesIndex]
																					.long_name;
																		}
																	}
																	for (
																		var cityIndex = 0;
																		cityIndex <
																		place.address_components[placesIndex].types
																			.length;
																		cityIndex++
																	) {
																		if (
																			place.address_components[placesIndex]
																				.types[cityIndex] ===
																				"administrative_area_level_2" ||
																			place.address_components[placesIndex]
																				.types[cityIndex] === "locality"
																		) {
																			city =
																				place.address_components[placesIndex]
																					.long_name;
																		}
																	}
																	for (
																		var provinceIndex = 0;
																		provinceIndex <
																		place.address_components[placesIndex].types
																			.length;
																		provinceIndex++
																	) {
																		if (
																			place.address_components[placesIndex]
																				.types[provinceIndex] ===
																			"administrative_area_level_1"
																		) {
																			province =
																				place.address_components[placesIndex]
																					.long_name;
																		}
																	}
																	for (
																		var countryIndex = 0;
																		countryIndex <
																		place.address_components[placesIndex].types
																			.length;
																		countryIndex++
																	) {
																		if (
																			place.address_components[placesIndex]
																				.types[countryIndex] === "country"
																		) {
																			country =
																				place.address_components[placesIndex]
																					.long_name;
																		}
																	}
																	for (
																		var postalIndex = 0;
																		postalIndex <
																		place.address_components[placesIndex].types
																			.length;
																		postalIndex++
																	) {
																		if (
																			place.address_components[placesIndex]
																				.types[postalIndex] === "postal_code"
																		) {
																			postalCode =
																				place.address_components[placesIndex]
																					.long_name;
																		}
																	}
																}
																this.setState({
																	geoAddress: address,
																});
																state.triageRequest.street = street;
																state.triageRequest.city = city;
																state.triageRequest.country = country;
																state.triageRequest.street_number =
																	street_number;
																state.triageRequest.postalCode = postalCode;
																state.triageRequest.province = province;
																state.triageRequest.lat =
																	place.geometry.location.lat();
																state.triageRequest.lng =
																	place.geometry.location.lng();

																resolve(place);
															} else {
																reject();
															}
														});
													});
												}}
												name="house"
												className={
													invalidFields.house
														? "is-error"
														: "text-field w-select"
												}
											>
												{({
													getInputProps,
													suggestions,
													getSuggestionItemProps,
													loading,
												}) => (
													<div>
														<input
															{...getInputProps({
																placeholder: checkAndGetSessionStorageValue(
																	"currentLocationName"
																),
																name: "location",
															})}
														/>

														<div>
															{loading && <div>Loading...</div>}
															{suggestions.map((suggestion) => {
																const className = suggestion.active
																	? "suggestion-item--active"
																	: "suggestion-item";
																const style = suggestion.active
																	? {
																			backgroundColor: "#fafafa",
																			cursor: "pointer",
																	  }
																	: {
																			backgroundColor: "#ffffff",
																			cursor: "pointer",
																	  };

																return (
																	<div
																		{...getSuggestionItemProps(suggestion, {
																			className,
																			style,
																		})}
																	>
																		<span>{suggestion.description}</span>
																	</div>
																);
															})}
														</div>
													</div>
												)}
											</PlacesAutocomplete>
										)}
									</div> </> ): <>
									<input
										type="text"
										name="address"
										className="mt-2"
										placeholder={i18next.t(
											"findcareoption.Careoptions.StreetAdress"
										)}
										defaultValue={
											state.triageRequest.location.hasOwnProperty("name")
												? state.triageRequest.location.name
												: fields.address
										}
									/>
									<input
										type="text"
										name="postalCode"
										placeholder={i18next.t(
											"findcareoption.Careoptions.PostalCode"
										)}
										defaultValue={fields.postalCode}
									/>
									<div className="row row-gutter-1">
										<div className="col col-md-6">
											<input
												type="text"
												name="country"
												placeholder={i18next.t(
													"findcareoption.Careoptions.country"
												)}
												defaultValue={
													state.triageRequest.location.hasOwnProperty("parts")
														? state.triageRequest.location.parts.country
														: fields.country
												}
											/>
										</div>
										<div className="col col-md-6">
											<input
												type="text"
												name="state"
												placeholder={i18next.t(
													"findcareoption.Careoptions.state"
												)}
												defaultValue={
													state.triageRequest.location.hasOwnProperty("parts")
														? state.triageRequest.location.parts
																.administrative_area_level_1
														: fields.state
												}
											/>
										</div>
									</div>
									<input
										type="text"
										name="city"
										placeholder={i18next.t("findcareoption.Careoptions.city")}
										defaultValue={
											state.triageRequest.location.hasOwnProperty("parts")
												? state.triageRequest.location.parts.locality
												: fields.city
										}
									/>
									</> }
									<textarea
										name="notes"
										className="mt-2"
										rows="4"
										placeholder={i18next.t(
											"findcareoption.Careoptions.notes"
										)}
										defaultValue={fields.notes}
									></textarea>

									{checkAndGetSessionStorageValue("IsValidUser") === "true" ? (
										<>
									<h5>
										<Trans i18nKey="userregistration.Insurance">
											Insurance info:
										</Trans>
									</h5>

									<input
										id="insurance-input"
										type="text"
										name="insurance"
										defaultValue={
											state.triageRequest.data &&
											state.triageRequest.data.insurance
												? state.triageRequest.data.insurance.trim()
												: fields.insurance
										}
										className={cx(invalidFields.insurance ? "is-error" : "")}
										placeholder={i18next.t("userregistration.insurancecarrier")}
										pattern="[A-Za-z0-9\s.]{0,}[\S]{1,}[\s]{0,}"
									/>

									<input
										id="insurance-input"
										type="text"
										name="policyNum"
										defaultValue={
											state.triageRequest.data &&
											state.triageRequest.data.policyNum
												? state.triageRequest.data.policyNum.trim()
												: fields.policyNum
										}
										placeholder={i18next.t("userregistration.Policy")}
										pattern="[A-Za-z0-9\s.]{0,}[\S]{1,}[\s]{0,}"
										className={cx(invalidFields.policyNum ? "is-error" : "")}
									/>

									<div className="w-col pr-3 pl-0 w-col-6 w-col-tiny-tiny-stack">
										<input
											id="date-effect"
											type="text"
											name="effectFrom"
											min={policyFromMinDate}
											max={getCurrentDate}
											defaultValue={
												state.triageRequest.profile &&
												state.triageRequest.profile.effectFrom
													? state.triageRequest.profile.effectFrom.trim()
													: fields.effectFrom
											}
											placeholder={i18next.t("findcareoption.Start.travelDateFrom")}

											className={cx(
												invalidFields.effectFrom
													? "is-error w-input"
													: "w-input"
											)}
											onChange={(e) => {
												policyToMaxDate = getDate(
													new Date(e.currentTarget.value),
													1
												);
												setState({
													enteredStartdate: e.currentTarget.value,
												});
												check(e);
											}}
											onFocus={(e) => {
												e.currentTarget.type = "date";
											}}
											onBlur={(e) => {
												e.currentTarget.placeholder =
													"Travel Date From: (dd/mm/yyyy)";
											}}
										/>
									</div>
									<div className="w-col pr-0 pl-0 w-col-6 w-col-tiny-tiny-stack">
										<input
											id="date-effectto"
											type="text"
											name="effectTo"
											min={policyToMinDate}
											max={policyToMaxDate}
											defaultValue={
												state.triageRequest.profile &&
												state.triageRequest.profile.effectTo
													? state.triageRequest.profile.effectTo.trim()
													: fields.effectTo
											}
											placeholder={i18next.t("findcareoption.Start.travelDateTo")}

											className={cx(
												invalidFields.effectTo ? "is-error w-input" : "w-input"
											)}
											onChange={(e) => {
												setState({
													enteredEnddate: e.currentTarget.value,
												});
												check(e);
											}}
											onFocus={(e) => {
												e.currentTarget.type = "date";
											}}
											onBlur={(e) => {
												e.currentTarget.placeholder =
													"Travel Date To: (dd/mm/yyyy)";
											}}
										/>
									</div>
									<div className="w-col p-1 w-col-tiny-tiny-stack">
										<div className="column-2 w-col w-col-9 w-col-tiny-tiny-stack insured text-bold">
											<Trans i18nKey="userregistration.toggle-msg">
												Are you the primary insured on the policy?
											</Trans>
										</div>
										<div className="column-2 w-col w-col-3 w-col-tiny-tiny-stack primary-policy">
											<Switch
												checked={this.state.checked}
												onChange={this.handleChange}
												onColor="#006fd6"
												onHandleColor="#2693e6"
												handleDiameter={30}
												checkedIcon={
													<div className="Yes-toggle">
														<Trans i18nKey="userregistration.toggle-yes">
															Yes
														</Trans>
													</div>
												}
												uncheckedIcon={
													<div className="No-Toggle">
														<Trans i18nKey="userregistration.toggle-no">
															No
														</Trans>
													</div>
												}
												className="react-switch"
												id="material-switch"
											/>
										</div>
									</div>
									{!this.state.checked ? (
										<div>
											<h5>
												<Trans i18nKey="userregistration.primaryInsured">
													About Primary Insured
												</Trans>
											</h5>
											<input
												type="text"
												name="insuredOn"
												placeholder={i18next.t("findcareoption.Start.Name")}
												defaultValue={fields.name}
											/>

											<div className="w-col pr-3 pl-0 w-col-6 w-col-tiny-tiny-stack">
												<input
													type="text"
													defaultValue={
														state.triageRequest.profiles
															? state.triageRequest.profiles.date.trim()
															: fields.date
													}
													className="w-input"
													placeholder={i18next.t("userregistration.user-DOB")}
													name="InsuredBirthday"
													pattern="\s{0,}\d{1,2}/\d{1,2}/\d{4}\s{0,}"
													onFocus={(e) => {
														e.currentTarget.type = "date";
													}}
													onBlur={(e) => {
														e.currentTarget.placeholder = "DOB (dd/mm/yyyy)";
													}}
												/>
											</div>

											<div className="w-col pt-2 w-col-3 w-col-tiny-tiny-stack">
												<input
													id="gender-radio"
													type="radio"
													value={i18next.t(
														"userregistration.radio-male"
													  )}
													onChange={(e) => {
														state.triageRequest.userGenderPrimary =
															e.currentTarget.value;
													}}
													name="sex"
													pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
													className="w-radio-input"
												/>
												<span className="w-radio w-radio-textsize">
													<Trans i18nKey="userregistration.radio-male">
														Male
													</Trans>
												</span>
											</div>
											<div classname="w-col pt-2 w-col-3 w-col-tiny-tiny-stack">
												<input
													id="gender-radio-1"
													type="radio"
													value={i18next.t(
														"userregistration.radio-female"
													  )}
													onChange={(e) => {
														state.triageRequest.userGenderPrimary =
															e.currentTarget.value;
													}}
													name="sex"
													pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
													className="w-radio-input"
												/>
												<span className="w-radio mt-2 w-radio-textsize">
													<Trans i18nKey="userregistration.radio-female">
														Female
													</Trans>
												</span>
											</div>

											<div>
												<select id="RelationList" name="relation">
												<option value="" disabled selected>
													{i18next.t("userregistration.step4_select.relation")}
												</option>
													<option value={i18next.t("userregistration.step4_select.self")}>													
														{i18next.t("userregistration.step4_select.self")}
													</option>
													<option value={i18next.t("userregistration.step4_select.child")}>
														{i18next.t("userregistration.step4_select.child")}{" "}
													</option>
													<option value={i18next.t(
														"userregistration.step4_select.employee"
													)}>
														{i18next.t(
															"userregistration.step4_select.employee"
														)}
													</option>
													<option value={i18next.t("userregistration.step4_select.father")}>
														{i18next.t("userregistration.step4_select.father")}
													</option>
													<option value={i18next.t("userregistration.step4_select.mother")}>
														{i18next.t("userregistration.step4_select.mother")}
													</option>
													<option value={i18next.t("userregistration.step4_select.brother")}>
														{i18next.t("userregistration.step4_select.brother")}
													</option>
													<option value={i18next.t("userregistration.step4_select.sister")}>
														{i18next.t("userregistration.step4_select.sister")}
													</option>
													<option value={i18next.t(
														"userregistration.step4_select.fosterchild"
													)}>
														{i18next.t(
															"userregistration.step4_select.fosterchild"
														)}
													</option>
													<option value={i18next.t(
														"userregistration.step4_select.grandfather"
													)}>
														{i18next.t(
															"userregistration.step4_select.grandfather"
														)}
													</option>
													<option value={i18next.t(
														"userregistration.step4_select.grandmother"
													)}>
														{i18next.t(
															"userregistration.step4_select.grandmother"
														)}
													</option>
													<option value={i18next.t(
														"userregistration.step4_select.grandsonorgranddaughter"
													)}>
														{i18next.t(
															"userregistration.step4_select.grandsonorgranddaughter"
														)}
													</option>
													<option value={i18next.t(
														"userregistration.step4_select.lifepartner"
													)}>
														{i18next.t(
															"userregistration.step4_select.lifepartner"
														)}
													</option>
													<option value={i18next.t("userregistration.step4_select.nephew")}>
														{i18next.t("userregistration.step4_select.nephew")}
													</option>
													<option value={i18next.t("userregistration.step4_select.niece")}>
														{i18next.t("userregistration.step4_select.niece")}
													</option>
													<option value={i18next.t("userregistration.step4_select.husband")}>
														{i18next.t("userregistration.step4_select.husband")}
													</option>
													<option value={i18next.t("userregistration.step4_select.wife")}>
														{i18next.t("userregistration.step4_select.wife")}
													</option>
													<option value={i18next.t(
														"userregistration.step4_select.sponsoreddependent"
													)}>
														{i18next.t(
															"userregistration.step4_select.sponsoreddependent"
														)}
													</option>
													<option value={i18next.t("userregistration.step4_select.stepson")}>
														{i18next.t("userregistration.step4_select.stepson")}
													</option>
													<option value={i18next.t(
														"userregistration.step4_select.stepdaughter"
													)}>
														{i18next.t(
															"userregistration.step4_select.stepdaughter"
														)}
													</option>
													<option value={i18next.t(
														"userregistration.step4_select.otherrelationship"
													)}>
														{i18next.t(
															"userregistration.step4_select.otherrelationship"
														)}
													</option>
												</select>
											</div>
										</div>
									) : (
										""
									)}

									<Modal
										isOpen={state.isHcCoverageAvailable}
										contentLabel="customStyles"
										className="ReactModal__Content_triagepopup"
										overlayClassName="ReactModal__Overlay_triagepopup"
									>
										<label className="confirm_title">
											<label>
												{" "}
												<Trans i18nKey="findcareoption.housevisitmodal">
													Sorry the revised address is outside of our House Call
													coverage area, would you like to go back and edit the
													location or try to select another service
												</Trans>{" "}
											</label>
										</label>

										<div className="pop_button">
											<button
												className="modal_no"
												onClick={(e) => {
													setState({
														isHcCoverageAvailable: false,
													});
												}}
											>
												<Trans i18nKey="findcareoption.location.Edit">
													Edit
												</Trans>
											</button>
											<button
												className="modal_no"
												onClick={(e) => {
													setState({
														isHcCoverageAvailable: false,
													});
													history.push(`/find-care-options/care-options`);
												}}
											>
												<Trans i18nKey="Services">Services</Trans>
											</button>
										</div>
									</Modal>
									</> ): "" }
									<button
										type="submit"										
										className={cx(
											"button standby-button standby-button-gradient standby-button-full-width standby-button-gradient-green" /* : 'btn-screen-nav--disabled' */
										)}
										//disabled={!isValid}
									>
										<Trans i18nKey="findcareoption.Careoptions.housevisit.Next">
											Next
										</Trans>
									</button>
									<div className="standby-page-header standby-page-header-center pb-3">
									<Link
										className="standby-button-back"
										to={`/find-care-options/care-options`}
									>
										<div className="icon">
											<svg
												version="1.1"
												xmlns="http://www.w3.org/2000/svg"
												width="10"
												height="10"
												viewBox="0 0 1024 1024"
											>
												<path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
											</svg>
										</div>
										<Trans i18nKey="findcareoption.Careoptions.telemedicine.Cancelrequest">
											Cancel Request
										</Trans>
									</Link>
								</div>	
									{isValid ? (
										""
									) : (
										<p
											style={{ marginBottom: "20px" }}
											className="color-dark-gray text-small"
										>
											<Trans i18nKey="findcareoption.Careoptions.housevisit.HouseVisitvalidationMsg">
												Please make sure to fill all required fields.
											</Trans>
										</p>
									)}							
						</LoadingScreen>
					)}
				</Form>
			</div>
		);
	}
}
